<div class="main-view space-y-2 md:space-y-4">
  <app-page-surface-header
    titleIcon="lock"
    title="Audit Log"
    subtitle="Every create, edit and delete made in this portal — who did it, when, and from where."
  >
    <ng-container ngProjectAs="[pageHeaderActions]">
      <!-- Chain check is on demand: it walks the whole log, so it is not run on every visit. -->
      <button
        type="button"
        class="inline-flex items-center gap-2 rounded-full px-3 py-1.5 text-xs font-medium transition-colors"
        [ngClass]="{
          'bg-gray-100 text-gray-600 hover:bg-gray-200 dark:bg-white/5 dark:text-gray-300 dark:hover:bg-white/10':
            !verify,
          'bg-emerald-100 text-emerald-700 dark:bg-emerald-950/50 dark:text-emerald-300': verify?.valid,
          'bg-red-100 text-red-700 dark:bg-red-950/50 dark:text-red-300': verify && !verify.valid
        }"
        [disabled]="verifying"
        (click)="runVerify()"
        title="Recompute every entry's hash to prove nothing was altered"
      >
        <icon-refresh class="h-3.5 w-3.5" [class.animate-spin]="verifying" />
        @if (verifying) { Checking integrity… } @else if (!verify) { Check integrity } @else if (verify.valid) { Log
        intact · {{ verify.count }} entries } @else { Tampering detected at entry #{{ verify.broken_at_id }} }
      </button>
    </ng-container>
  </app-page-surface-header>

  <app-list-module-surface
    [config]="listSurfaceConfig"
    [filters]="listFilters"
    [errorMessage]="error"
    [loading]="loading"
    [meta]="meta"
    [rowCount]="rows.length"
    (filtersChange)="onListFiltersChange($event)"
    (pageChange)="onListPageChange($event)"
  >
    <ng-container toolbarFiltersExtra>
      <button
        type="button"
        class="btn inline-flex shrink-0 items-center gap-2 rounded-xl border px-3 py-2 text-sm font-medium shadow-none"
        [ngClass]="
          extraCount
            ? 'border-primary/40 bg-primary/10 text-primary'
            : 'border-gray-200 bg-white text-gray-700 hover:bg-gray-50 dark:border-[#191e3a] dark:bg-[#0e1726] dark:text-white dark:hover:bg-white/5'
        "
        (click)="moreOpen = !moreOpen"
        [attr.aria-expanded]="moreOpen"
      >
        More filters @if (extraCount) {
        <span class="rounded-full bg-primary px-1.5 text-[10px] text-white">{{ extraCount }}</span> }
      </button>
    </ng-container>

    <ng-container toolbarActions>
      <button
        type="button"
        class="btn inline-flex shrink-0 items-center gap-2 rounded-xl border border-gray-200 bg-white px-3 py-2 text-sm font-medium text-gray-700 shadow-none hover:bg-gray-50 disabled:opacity-50 dark:border-[#191e3a] dark:bg-[#0e1726] dark:text-white dark:hover:bg-white/5"
        [disabled]="exporting"
        (click)="exportCsv()"
        title="Export the filtered log as CSV"
      >
        <icon-download class="size-4" />
        {{ exporting ? 'Exporting…' : 'Export CSV' }}
      </button>
    </ng-container>

    <div listTable>
      @if (moreOpen) {
      <div
        class="mb-3 grid grid-cols-1 gap-3 rounded-xl border border-gray-200 bg-gray-50/60 p-3 dark:border-[#191e3a] dark:bg-white/5 sm:grid-cols-2 lg:grid-cols-5"
      >
        <div>
          <label for="audit-filter-resource" class="mb-1 block text-xs font-medium text-gray-500">Record type</label>
          <input
            id="audit-filter-resource"
            type="text"
            class="form-input text-sm"
            placeholder="tenant, role, api_key…"
            [(ngModel)]="extra.resource_type"
            (keydown.enter)="applyExtra()"
          />
        </div>
        <div>
          <label for="audit-filter-source" class="mb-1 block text-xs font-medium text-gray-500">Recorded by</label>
          <select id="audit-filter-source" class="form-select text-sm" [(ngModel)]="extra.source">
            <option value="">Any service</option>
            <option value="super-admin">Super admin</option>
            <option value="tenant-admin">Tenant admin</option>
            <option value="gateway">Gateway</option>
          </select>
        </div>
        <div>
          <label for="audit-filter-tenant" class="mb-1 block text-xs font-medium text-gray-500">Tenant ID</label>
          <input
            id="audit-filter-tenant"
            type="number"
            class="form-input text-sm"
            [(ngModel)]="extra.tenant_id"
            (keydown.enter)="applyExtra()"
          />
        </div>
        <div>
          <label for="audit-filter-ip" class="mb-1 block text-xs font-medium text-gray-500">IP address</label>
          <input
            id="audit-filter-ip"
            type="text"
            class="form-input font-mono text-sm"
            [(ngModel)]="extra.source_ip"
            (keydown.enter)="applyExtra()"
          />
        </div>
        <div class="flex items-end gap-2">
          <button type="button" class="btn btn-primary rounded-xl px-4 py-2 text-sm" (click)="applyExtra()">
            Apply
          </button>
          <button
            type="button"
            class="btn rounded-xl border border-gray-200 px-4 py-2 text-sm shadow-none dark:border-[#191e3a]"
            (click)="clearExtra()"
          >
            Clear
          </button>
        </div>
      </div>
      }
      <app-audit-log-table [rows]="rows" [loading]="loading" (view)="selected = $event" />
    </div>
  </app-list-module-surface>
</div>

<app-audit-entry-drawer [row]="selected" (closed)="selected = null" />
